import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "filters-bar" }
const _hoisted_2 = {
  key: 0,
  class: "filter-item"
}
const _hoisted_3 = { value: "" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "search-group" }
const _hoisted_6 = { class: "search-container" }
const _hoisted_7 = ["placeholder"]

import { ref, watch, onMounted, onUnmounted, computed } from "vue";
import { useUtilitiesStore } from "@/stores/utilities";
import { useIntegrationMode } from '@/composables/useIntegrationMode'


const __default__ = {
  name: "LotteryFilters",
};


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    activeCountrySlugs: { default: undefined }
  },
  emits: ["search", "filterCountry"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const search = ref("");
const country = ref("");
const isMobileViewport = ref(false);

const utilitiesStore = useUtilitiesStore();
const { isLite } = useIntegrationMode()

const updateViewport = () => {
  isMobileViewport.value = typeof window !== 'undefined' && window.innerWidth <= 768;
};

onMounted(() => {
  updateViewport();
  window.addEventListener('resize', updateViewport);
  if (!isLite.value) {
    utilitiesStore.fetchCountries();
  }
});

onUnmounted(() => {
  window.removeEventListener('resize', updateViewport);
});

const countryOptions = computed(() => {
  const all = utilitiesStore.countries || [];
  const active = props.activeCountrySlugs;
  // Active-draw country filter is mobile-only per Aug 7 review
  if (!isMobileViewport.value || !active || active.length === 0) return all;
  const activeSet = new Set(active.map((slug) => String(slug).toLowerCase()));
  return all.filter((c) => activeSet.has(String(c.slug).toLowerCase()));
});

watch(countryOptions, (options) => {
  if (country.value && !options.some((c) => c.slug === country.value)) {
    country.value = '';
    emit('filterCountry', '');
  }
});

const onSearch = () => emit("search", search.value);
const onCountryFilter = () => emit("filterCountry", country.value);

watch([search, country], () => {
  emit("search", search.value);
  emit("filterCountry", country.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isLite))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((country).value = $event)),
            class: "filter-select",
            onChange: onCountryFilter
          }, [
            _createElementVNode("option", _hoisted_3, _toDisplayString(_ctx.$t('forms.allCountries')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countryOptions.value, (c) => {
              return (_openBlock(), _createElementBlock("option", {
                key: c.slug,
                value: c.slug
              }, _toDisplayString(c.name), 9, _hoisted_4))
            }), 128))
          ], 544), [
            [_vModelSelect, country.value]
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
          type: "text",
          inputmode: "text",
          "data-keyboard": "text",
          class: "search-input",
          placeholder: _ctx.$t('forms.searchGamesPlaceholder'),
          onInput: onSearch
        }, null, 40, _hoisted_7), [
          [_vModelText, search.value]
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("button", {
          class: "search-button",
          type: "button"
        }, [
          _createElementVNode("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("circle", {
              cx: "11",
              cy: "11",
              r: "8"
            }),
            _createElementVNode("line", {
              x1: "21",
              y1: "21",
              x2: "16.65",
              y2: "16.65"
            })
          ])
        ], -1))
      ])
    ])
  ]))
}
}

})